import { resetFlowsMetaData } from '../store/redux/slices/flowsMetaDataSlice';
import { resetFlows } from '../store/redux/slices/flowsSlice';
import store from '../store/redux/store';

interface ResetState {
  reset: () => void;
}

const useFlowsResetState = (): ResetState => {
  const reset = () => {
    store.dispatch(resetFlows());
    store.dispatch(resetFlowsMetaData());
  };

  return { reset };
};

export default useFlowsResetState;
